import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {KtPaymentsFilterService} from '../../service/kt-payments-filter.service';
import {KtPaymentFilterModel} from '../../models/kt-filter.model';

@Component({
  selector: 'app-kt-payments-filter-modal',
  imports: [
    MatButton,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatSuffix,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './kt-payments-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
  `],
})
export class KtPaymentsFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<KtPaymentsFilterModalComponent>);
  private readonly filterService = inject(KtPaymentsFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;
  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const f = this.filterService.filtersValue();
    this.form.patchValue({
      TripReference: f.TripReference,
      TravelerName: f.TravelerName,
      ProductTypeName: f.ProductTypeName,
      PaymentDateFrom: f.PaymentDateFrom,
      PaymentDateTo: f.PaymentDateTo,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: KtPaymentFilterModel = {
      TripReference: raw.TripReference,
      TravelerName: raw.TravelerName,
      ProductTypeName: raw.ProductTypeName,
      PaymentDateFrom: raw.PaymentDateFrom,
      PaymentDateTo: raw.PaymentDateTo,
      ReloadGrid: true,
    };
    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      TripReference: null,
      TravelerName: null,
      ProductTypeName: null,
      PaymentDateFrom: null,
      PaymentDateTo: null,
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
